import startsWith from 'lodash/startsWith';
import endsWith from 'lodash/endsWith';

export function setupUrl(subdomain = null, apiVersion = 'v2') {
  const fullBackendHost = window.API_BASE_URL ? window.API_BASE_URL : window.location.hostname;
  const clearedHost = fullBackendHost.replace(/https?:\/\//, '');
  subdomain = subdomain && !startsWith(clearedHost, subdomain) ? `${subdomain}.` : '';
  return `//${subdomain}${clearedHost}${endsWith(clearedHost, '/') ? '' : '/'}${apiVersion}`;
}

export const getCookieHost = () => window.location.hostname.substring(window.location.hostname.indexOf('.'));

export const getPreviewUrl = (event, user) => {
  const currentUrl = window.location.href;

  if (currentUrl.includes('edit')) {
    return currentUrl.replace('#/checkout', '');
  }
  const eventId = event.get('id');
  let previewUrl = `/events/${eventId}/edit`;

  if(currentUrl.includes('new.')){
    if(currentUrl.includes('/#/checkout')){
      previewUrl = currentUrl.replace('/#/checkout', previewUrl) + `?token=${user.get('token')}`;
    }else{
      previewUrl = currentUrl.replace('#/checkout', '')
        .replace('/?with_navbar', previewUrl + '/?with_navbar')
        .replace('/?form_data', previewUrl + '/?form_data')
        .replace('/?partner', previewUrl + '/?partner') + `&token=${user.get('token')}`;
    }
  }

  return previewUrl;
}

export const titleize = sentence => {
  if(!sentence) return '';

  const _titleizeWord = string => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

  let result = [];
  sentence.split(' ').forEach(word => result.push(_titleizeWord(word)));

  return result.join(' ');
}

export const currencySigns = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'CAD': '$'
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/support.js